exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html,\nbody,\n#root {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden; }\n\nbody {\n  font-family: \"Roboto\", sans-serif;\n  -webkit-font-smoothing: subpixel-antialiased;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  color: #bbbbbb;\n  font-size: 12px; }\n\na {\n  text-decoration: none;\n  color: inherit; }\n\n* {\n  box-sizing: border-box; }\n\ninput,\nselect,\ntextarea,\nbutton {\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  background: none;\n  border: none;\n  outline: none;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  line-height: 1.15; }\n", ""]);

// Exports
exports.locals = {
	"themeDark": "#242424",
	"themeNormal": "#393939",
	"themeLight": "#505050",
	"colorFont": "#bbbbbb",
	"colorShadow": "rgba(0, 0, 0, 0.2)",
	"colorOverlay": "rgba(255, 255, 255, 0.1)",
	"colorAlert": "#f3bd58",
	"colorSelected": "#2962ff",
	"colorPatched": "#c51162",
	"colorHighlight": "#29d",
	"colorActive": "#00e676",
	"lineHeight": "32px",
	"fontSizeNormal": "12px",
	"fontSizeLarge": "14px"
};